import styled from 'styled-components'

export const Wrapper = styled.p`
  font-weight: var(--font-regular);
  font-size: 12px;
  line-height: 1.2;
  color: var(--brand-secondary);
  text-align: center;
  padding: 0 10px;
  text-wrap: balance;

  a {
    color: var(--brand-secondary);
    display: inline-block;
  }
`
